export const messages = {
  en: {
    privilegeStaffInfo: {
      title: 'Staff Information',
      staffId: 'Staff ID',
      staffName: 'Staff Name',
      phone: 'Phone',
      email: 'Email',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      address: 'Address',
      locateStaff: 'Locate Staff',
      addPrivilege: 'Add Privilege',
      search: 'Search'
    }
  },
  zh: {
    privilegeStaffInfo: {
      title: '员工信息',
      staffId: '员工ID',
      staffName: '员工姓名',
      phone: '手机号',
      email: '邮箱',
      gender: '性别',
      male: '男',
      female: '女',
      address: '地址',
      locateStaff: '定位员工',
      addPrivilege: '添加权限',
      search: '查询'
    }
  }
}